import Cookies from 'js-cookie'
import { getGlobalTodo } from '@/api/api'

const app = {
  state: {
    sidebar: {
      opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
      withoutAnimation: false
    },
    device: 'desktop',
    language: 'zh',
    size: 'medium',
    todoList: [],
    schoolCode: ''
    // publicInfo: {
    //   exercise_type: [
    //     {
    //       code: '1212',
    //       type: 1012,
    //       name: 'Topic',
    //       desc: '1012'
    //     },
    //     {
    //       code: '12122',
    //       type: 1020,
    //       name: 'TopicBoolean',
    //       desc: '1020'
    //     },
    //     {
    //       code: '12123',
    //       type: 1030,
    //       name: 'TopicFill',
    //       desc: '1030'
    //     },
    //     {
    //       code: '12124',
    //       type: 1040,
    //       name: 'TopicQa',
    //       desc: '1040'
    //     },
    //     {
    //       code: '12125',
    //       type: 1041,
    //       name: 'TopicAIRecord',
    //       desc: '1041'
    //     },
    //     {
    //       code: '12126',
    //       type: 2010,
    //       name: 'TopicRereading',
    //       desc: '2010'
    //     }
    //   ]
    // } //公共信息
  },
  mutations: {
    TOGGLE_SIDEBAR: state => {
      state.sidebar.opened = !state.sidebar.opened
      state.sidebar.withoutAnimation = false
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set('sidebarStatus', 0)
      state.sidebar.opened = false
      state.sidebar.withoutAnimation = withoutAnimation
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    },
    SET_LANGUAGE: (state, language) => {
      state.language = 'zh'
      Cookies.set('language', language)
    },
    SET_SIZE: (state, size) => {
      state.size = size
      Cookies.set('size', size)
    },
    setTodoPolling: (state, data) => {
      if (data === null) {
        clearInterval(state.todoPolling)
      } else {
        state.todoPolling = data
      }
    },
    setGlobalTodo: (state, data) => {
      state.todoList = data
    },
    setTodoNum: (state, data) => {
      let index = state.todoList.findIndex(todo => todo.serviceCode === data.type)
      let todoList = JSON.parse(JSON.stringify(state.todoList))
      todoList[index].toDoCount = data.num
      state.todoList = JSON.parse(JSON.stringify(todoList))
    }
  },
  actions: {
    toggleSideBar({ commit }) {
      commit('TOGGLE_SIDEBAR')
    },
    closeSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    toggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    },
    setLanguage({ commit }, language) {
      // console.log('asdfasdfsadf', language)
      commit('SET_LANGUAGE', 'zh')
    },
    setSize({ commit }, size) {
      commit('SET_SIZE', size)
    },
    getGlobalTodo({ commit }) {
      return new Promise((resolve, reject) => {
        getGlobalTodo()
          .then(res => {
            commit('setGlobalTodo', res)
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    }
  }
}

export default app
